import { useParams, useSearchParams } from "react-router-dom"
import PageContainer from "../../components/PageContainer"
import { useEffect, useRef, useState } from "react";
import Loader from '../../components/Loader';

const CompanyHandleRequest = () => {

    // Catturo i dati query
    const { requestId } = useParams();
    const [params] = useSearchParams();
    const companySentence = params.get('companySentence');
    const token = params.get('token');
    const [error, setError] = useState(false);
    const [fetchStatus, setFetchStatus] = useState('loading');
    const hasFetched = useRef(false);
    useEffect(() => {
        if (hasFetched.current) return;
        hasFetched.current = true;
        if (requestId && companySentence) {
            sendRequestReply()
        } else {
            setError(true)
        }

        // Funzione di fetch
        async function sendRequestReply() {
            let url;
            if (companySentence === 'true') {
                url = `${process.env.REACT_APP_SERVER_BASE_URL}/requests/accept-request/${requestId}`;
            } else if (companySentence === 'false') {
                url = `${process.env.REACT_APP_SERVER_BASE_URL}/requests/decline-request/${requestId}`;
            }
            const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
            const options = { method: 'PATCH', headers };
            try {
                const response = await fetch(url, options);
                if (response.ok) {
                    await response.json();
                    setFetchStatus('succeeded');
                } else {
                    const error = await response.json();
                    throw error
                }
            } catch (error) {
                console.log('error: ', error);
                setFetchStatus('error');
                setError(error.message || "Errore sconosciuto.");
            }

        }
    }, [requestId, companySentence, token])


    return (
        <PageContainer items="center">
            <div className="flex flex-col gap-2 items-center justify-center min-h-[500px]">
                {
                    fetchStatus === 'loading' &&
                    <Loader />
                }
                {
                    fetchStatus === 'error' && error &&
                    <div>
                        <h4 className="text-red-500">{error}</h4>
                        <p>Annota l'id della richiesta e contatta lo staff TicinoWild</p>
                        <p><b>Id richiesta d'acquisto: {requestId}</b></p>
                    </div>
                }
                {
                    companySentence === 'true' &&
                    fetchStatus === 'succeeded' &&
                    <div>
                        <h3>Hai <span className="text-green-500">accettato</span> la richiesta</h3>
                        <p>All'utente è stata inviata un'email con le istruzioni per effettuare il pagamento.</p>
                        <p>Appena esso verrà effettuato, egli riceverà un'email con i vostri contatti per effettuare la prenotazione.</p>
                        <p>Lo staff di <b>TicinoWild</b></p>
                    </div>
                }
                {
                    companySentence === 'false' &&
                    fetchStatus === 'succeeded' &&
                    <div>
                        <h3>Hai <span className="text-red-500">declinato</span> la richiesta</h3>
                        <p>All'utente è stata inviata un'email di notifica.</p>
                        <p>Lo staff di <b>TicinoWild</b></p>
                    </div>
                }
            </div>

        </PageContainer>
    )
}

export default CompanyHandleRequest